module.exports = __webpack_public_path__ + "/content/shared/img/bentley/email-bentley-last-chance-sale-is-live.png";